(() => {
  if (window.kkJulMobile2026) return;
  window.kkJulMobile2026 = true;

  const pausedClass = 'kk-jul-overlay-paused';
  const observed = new WeakSet();
  let scheduled = false;

  function intersects(a, b) {
    return a.width > 0 && a.height > 0 && a.left < b.right && a.right > b.left && a.top < b.bottom && a.bottom > b.top;
  }

  function update() {
    scheduled = false;
    const summary = document.querySelector('.kk-jul-product-summary');
    const info = summary?.closest('product-info');
    const controls = info ? [...info.querySelectorAll('[data-kk-jul-2026-input], [id^="ProductSubmitButton-"]')]
      .filter((control) => !control.disabled && !control.closest('[hidden]') && control.getClientRects().length)
      .map((control) => control.getBoundingClientRect()) : [];
    const mobile = window.matchMedia('(max-width: 749px)').matches;

    for (const host of document.querySelectorAll('shopify-chat, shopify-forms-embed')) {
      const root = host.shadowRoot;
      if (root && !observed.has(root)) {
        observed.add(root);
        new MutationObserver(schedule).observe(root, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['aria-expanded', 'data-current-step'],
        });
      }

      const chatButton = root?.querySelector('button[part="activator"]');
      const teaser = root?.querySelector('[data-current-step="tease"] [data-testid="form-teaser"]');
      const launcher = chatButton?.getAttribute('aria-expanded') === 'false' ? chatButton : teaser;
      const focused = root?.activeElement;
      const collision = mobile && info && launcher && !focused && controls.some((control) => {
        const rect = launcher.getBoundingClientRect();
        return control.bottom > 0 && control.top < window.innerHeight && intersects(rect, control);
      });
      host.classList.toggle(pausedClass, Boolean(collision));
    }
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(update);
  }

  document.addEventListener('scroll', schedule, { passive: true, capture: true });
  window.addEventListener('resize', schedule, { passive: true });
  document.addEventListener('focusin', schedule);
  document.addEventListener('focusout', schedule);
  document.addEventListener('shopify:section:load', schedule);
  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  schedule();
})();
